import { tns } from 'tiny-slider/src/tiny-slider';
// import media from '../../../tokens/js/utils/vars/media';
import media from 'tokens/js/utils/vars/media';

const carousels = document.querySelectorAll('.carousel');
const baseSettings = {
  mouseDrag: true,
  loop: false,
  lazyload: false,
  arrowKeys: true,
  autoplayHoverPause: true,
  autoplayText: ['▶', '❚❚'],
};

carousels.forEach((carousel) => {
  const instanceSettings = carousel.dataset;

  const parsedInstanceSettings = {};
  /* eslint-disable-next-line */
  for (const [key, value] of Object.entries(instanceSettings)) {
    const realValue = (val) => {
      if (val === 'true') return true;
      if (val === 'false') return false;
      if (!Number.isNaN(Number(val))) return parseFloat(val);
      return val;
    };
    parsedInstanceSettings[key] = realValue(value);
  }

  const responsiveSettings = {
    items: 1, // plausible minimum value

    responsive: {
      [(media.breakpoints.phoneLarge + 1).toString()]: {
        items: 2,
      },
      [media.breakpoints.tablet.toString()]: {
        items: instanceSettings.items, // use settings from yml config
      },
    },
  };

  const settings = {
    container: carousel.querySelector('.carousel__track'),
    controlsContainer: carousel.querySelector('.carousel__controls'),
    // navContainer: carousel.querySelector('.carousel__bullets'),
    ...baseSettings,
    ...parsedInstanceSettings,
    ...responsiveSettings,
  };

  tns(settings);
});
